export var EditorTag = {
    /** Unknown tag value */
    Unknown: "Unknown",
    /** Edit tag value */
    Edit: "EDIT",
    /** DateTime tag value  */
    DateTime: "DATETIME",
    /** List tag value */
    List: "LIST",
    /** CustomList tag value */
    CustomList: "CUSTOMLIST",
    /** File tag value */
    File: "FILE"
};
//# sourceMappingURL=editor_tag.js.map